import { NAV_PROJECT_MANAGE } from '@/pages/performance/constants'
/**
 * 项目管理相关页面
 */
const PerfManagePages = {
  path: 'manage',
  component: () => import('../layout/layoutContent/contents/manageContent/index.vue'),
  meta: { name: '项目管理', nav: NAV_PROJECT_MANAGE },
  children: [
    {
      path: ':projectId',
      component: () => import('../pages/managePages/index.vue'),
      meta: { name: '成员列表' },
    }
  ]
}
export default PerfManagePages
